(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fan-product-personalization"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fan-gift-fields')) {
    customElements.define('fan-gift-fields', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const update = (field) => {
          const counter = this.querySelector('#' + CSS.escape(field.getAttribute('aria-describedby')));
          if (counter) counter.textContent = `${field.value.length} / ${field.maxLength}`;
        };
        this.querySelectorAll('input[maxlength], textarea[maxlength]').forEach(update);
        this.addEventListener('input', (event) => {
          if (event.target.matches('input[maxlength], textarea[maxlength]')) update(event.target);
        }, { signal: this.controller.signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fdbs-buy-form"] && !Shopify.designMode) return;
  try {
    document.addEventListener('input',event=>{if(event.target.matches('[data-fdbs-counter]')){event.target.closest('label').querySelector('.fdbs-counter').textContent=`${event.target.value.length} / ${event.target.maxLength}`;}});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fdbs-print-configurator"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fd-format-picker')) {
  class FdFormatPicker extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.labels = JSON.parse(this.querySelector('[data-format-labels]').textContent);
      this.innerHTML = '';
      this.groupsBox = document.createElement('fieldset');
      const legend = document.createElement('legend');
      legend.textContent = this.labels.shape;
      this.groupsBox.append(legend);
      this.groupButtons = document.createElement('div');
      this.groupButtons.className = 'fd-format-shapes';
      this.groupsBox.append(this.groupButtons);
      this.hint = document.createElement('p');
      this.hint.className = 'fd-format-hint';
      this.groupsBox.append(this.hint);
      this.sizesBox = document.createElement('fieldset');
      const sizeLegend = document.createElement('legend');
      sizeLegend.textContent = this.labels.size;
      this.sizesBox.append(sizeLegend);
      this.cards = document.createElement('div');
      this.cards.className = 'fd-format-sizes';
      this.sizesBox.append(this.cards);
      this.more = document.createElement('details');
      const summary = document.createElement('summary');
      summary.textContent = this.labels.more;
      this.more.append(summary);
      const label = document.createElement('label');
      const labelText = document.createElement('span');
      labelText.textContent = this.labels.all;
      this.select = document.createElement('select');
      label.append(labelText, this.select);
      this.more.append(label);
      this.sizesBox.append(this.more);
      this.notice = document.createElement('p');
      this.notice.className = 'fd-format-notice';
      this.notice.setAttribute('role', 'status');
      this.notice.hidden = true;
      this.append(this.groupsBox, this.sizesBox, this.notice);
      this.addEventListener('click', event => {
        const shape = event.target.closest('[data-format-group]');
        const size = event.target.closest('[data-format-row]');
        if (shape && !shape.disabled) {
          const row = this.options.rows.find(r => r.group === shape.dataset.formatGroup);
          if (row) this.options.onSelect(row.id);
        } else if (size) this.options.onSelect(size.dataset.formatRow);
      });
      this.select.addEventListener('change', () => this.options.onSelect(this.select.value));
    }
    setSelection(options) {
      if (!this.ready) this.connectedCallback();
      this.options = options;
      const row = options.rows.find(r => r.id === options.rowId);
      if (!row) return;
      const focus = this.contains(document.activeElement) ? document.activeElement : null;
      const focusGroup = focus?.dataset.formatGroup;
      const focusRow = focus?.dataset.formatRow;
      if (!this.groupButtons.children.length) {
        options.groups.forEach((group, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.dataset.formatGroup = group;
          const icon = document.createElement('span');
          icon.className = 'fd-format-symbol';
          icon.setAttribute('aria-hidden', 'true');
          icon.style.setProperty('--shape-ratio', [1.5, 4/3, 1, 3, 1.25, Math.SQRT2, 16/9][index] || 1.5);
          const name = document.createElement('span');
          name.textContent = group;
          button.append(icon, name);
          this.groupButtons.append(button);
        });
      }
      this.groupButtons.querySelectorAll('button').forEach(button => {
        button.disabled = !options.rows.some(r => r.group === button.dataset.formatGroup);
        button.setAttribute('aria-pressed', String(row.group === button.dataset.formatGroup));
      });
      const groupIndex = options.groups.indexOf(row.group);
      this.hint.textContent = this.labels.hints[groupIndex] || '';
      const rows = options.rows.filter(r => r.group === row.group);
      const featured = rows.slice(0, 4);
      if (!featured.some(r => r.id === row.id)) featured[featured.length - 1] = row;
      this.cards.replaceChildren();
      featured.forEach(item => {
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.formatRow = item.id;
        button.setAttribute('aria-pressed', String(item.id === row.id));
        const name = document.createElement('strong');
        name.textContent = item.format;
        const price = document.createElement('span');
        price.textContent = options.price(item);
        button.append(name, price);
        this.cards.append(button);
      });
      this.select.replaceChildren();
      rows.forEach(item => {
        const option = document.createElement('option');
        option.value = item.id;
        option.textContent = item.format + ' · ' + options.price(item);
        option.selected = item.id === row.id;
        this.select.append(option);
      });
      this.more.hidden = rows.length <= 4;
      if (focusGroup) Array.from(this.groupButtons.children).find(b => b.dataset.formatGroup === focusGroup)?.focus({preventScroll:true});
      if (focusRow) Array.from(this.cards.children).find(b => b.dataset.formatRow === focusRow)?.focus({preventScroll:true});
    }
  }
  customElements.define('fd-format-picker', FdFormatPicker);
}


if (!customElements.get('fdbs-print-configurator')) {
  class FdbsPrintConfigurator extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.catalog = JSON.parse(this.querySelector('[data-print-catalog]').textContent);
      this.live = JSON.parse(this.querySelector('[data-print-live]').textContent);
      this.money = new Intl.NumberFormat('de-DE', {style:'currency',currency:'EUR'});
      this.form = this.querySelector('form');
      this.picker = this.querySelector('fd-format-picker');
      this.materialKey = (this.catalog.materials.find(m => m.handle === this.dataset.initialMaterial) || this.catalog.materials[0]).key;
      this.rowId = '60x40';
      this.delivery = 'PAH';
      this.mount = false;
      const parameters = new URLSearchParams(window.location.search);
      const requestedMaterial = parameters.get('print_material');
      const requestedFormat = parameters.get('print_format');
      const requestedVariant = parameters.get('variant');
      let handoffError = false;
      if (requestedMaterial || requestedFormat) {
        const material = this.catalog.materials.find(item => item.key === (requestedMaterial || this.materialKey));
        const row = material && this.rowsFor(material.key).find(item => item.id === (requestedFormat || this.rowId));
        if (material && row) {
          this.materialKey = material.key;
          this.rowId = row.id;
        } else {
          handoffError = true;
        }
      } else if (requestedVariant) {
        const material = this.catalog.materials.find(item => (!this.dataset.initialMaterial || item.handle === this.dataset.initialMaterial) && (this.live.products[item.key]?.variants || []).some(variant => String(variant.id) === requestedVariant));
        const variant = material && this.live.products[material.key].variants.find(item => String(item.id) === requestedVariant);
        const row = material && this.rowsFor(material.key).find(item => ['PAH','POST'].some(delivery => [false,true].some(mount => this.variantFor(material.key,item,delivery,mount)?.id === variant.id)));
        if (row) {
          this.materialKey = material.key;
          this.rowId = row.id;
          this.delivery = variant.sku.endsWith('-POST') ? 'POST' : 'PAH';
          this.mount = variant.sku.includes('-MIT-');
        } else {
          handoffError = true;
        }
      }
      this.querySelectorAll('input[name="print_delivery"]').forEach(input => { input.checked = input.value === this.delivery; });
      this.querySelectorAll('input[name="print_material"]').forEach(input => { input.checked = input.value === this.materialKey; });
      this.querySelectorAll('[data-print-min]').forEach(node => {
        const prices = this.rowsFor(node.dataset.printMin).map(row => this.priceFor(node.dataset.printMin,row,'PAH'));
        node.textContent = this.money.format(Math.min.apply(null,prices)/100);
      });
      this.addEventListener('change', event => {
        if (event.target.name === 'print_material') {
          this.materialKey = event.target.value;
          this.mount = false;
          this.renderFormats();

        } else if (event.target.name === 'print_mount') {
          this.mount = this.materialKey === 'dibond' && event.target.value === 'MIT';
          this.update();
        } else if (event.target.name === 'print_delivery') {
          this.delivery = event.target.value;
          this.update();
        }
      });
      this.addEventListener('input', event => {
        if (!event.target.matches('[data-print-personal]')) return;
        const input = event.target;
        input.closest('label').querySelector('[data-print-counter]').textContent = input.value.length + ' / ' + input.maxLength;
        this.updatePersonal();
      });
      this.querySelector('[data-print-submit]').addEventListener('click', () => this.form.requestSubmit());
      this.form.addEventListener('submit', event => {
        if (!this.canBuy()) {
          event.preventDefault();
          this.querySelector('[data-print-error]').hidden = false;
        }
      });
      this.renderFormats();
      if (handoffError) {
        const notice = this.querySelector('[data-print-size-notice]');
        notice.textContent = this.dataset.handoffError;
        notice.hidden = false;
      }
      this.updatePersonal();
    }
    rowsFor(material) {
      return this.catalog.rows.filter(row => Number.isFinite(row.prices[material]));
    }
    variantFor(material,row,delivery,mount = false) {
      if (!row) return null;
      const spec = this.catalog.materials.find(item => item.key === material);
      if (!spec) return null;
      const sku = 'FDBS-GS-PRINT-' + spec.sku + '-' + row.id.toUpperCase() + (material === 'dibond' && mount ? '-MIT-' : '-') + delivery;
      return ((this.live.products[material] || {}).variants || []).find(variant => variant.sku === sku) || null;
    }
    priceFor(material,row,delivery) {
      const variant = this.variantFor(material,row,delivery);
      return variant ? variant.price : Math.round(row.prices[material]*100);
    }
    currentRow() {
      return this.rowsFor(this.materialKey).find(row => row.id === this.rowId);
    }
    canBuy() {
      const variant = this.variantFor(this.materialKey,this.currentRow(),this.delivery,this.mount);
      return Boolean(this.live.enabled && variant && variant.available);
    }
    renderFormats() {
      const rows = this.rowsFor(this.materialKey);
      const notice = this.querySelector('[data-print-size-notice]');
      notice.hidden = true;
      if (!rows.some(row => row.id === this.rowId)) {
        const previous = this.catalog.rows.find(row => row.id === this.rowId);
        const replacement = rows.find(row => row.group === previous?.group) || rows.find(row => row.id === '30x20') || rows[0];
        this.rowId = replacement.id;
        notice.textContent = (previous ? previous.format : 'Das bisherige Format') + ' ist in diesem Material nicht verfügbar. Vorausgewählt: ' + replacement.format + '. Bitte die Größe prüfen oder ein anderes Format wählen.';
        notice.hidden = false;
      }
      this.update();
    }
    update() {
      const row = this.currentRow();
      if (!row) return;
      const material = this.catalog.materials.find(item => item.key === this.materialKey);
      this.picker.setSelection({groups:this.catalog.groups,rows:this.rowsFor(this.materialKey),rowId:this.rowId,price:item=>this.money.format(this.priceFor(this.materialKey,item,this.delivery)/100),onSelect:id=>{this.rowId=id;this.querySelector('[data-print-size-notice]').hidden=true;this.update();}});
      this.querySelector('[data-print-detail]').textContent = material.detail;
      this.querySelector('[data-print-summary-material]').textContent = material.label;
      this.querySelector('[data-print-summary-format]').textContent = row.format;
      const selectedVariant = this.variantFor(this.materialKey,row,this.delivery,this.mount);
      const includesMount = this.materialKey === 'dibond' && this.mount;
      const total = selectedVariant ? selectedVariant.price : this.priceFor(this.materialKey,row,this.delivery) + (includesMount ? 1290 : 0);
      this.querySelector('[data-print-price]').textContent = this.money.format(total/100);
      this.querySelector('[data-print-mount-price]').hidden = !includesMount;
      const mountField = this.querySelector('[data-print-mount]');
      mountField.hidden = this.materialKey !== 'dibond';
      mountField.disabled = this.materialKey !== 'dibond';
      mountField.querySelectorAll('input').forEach(input => { input.checked = (input.value === 'MIT') === includesMount; });
      const mountSummary = this.querySelector('[data-print-summary-mount]');
      mountSummary.hidden = this.materialKey !== 'dibond';
      mountSummary.textContent = includesMount ? mountSummary.dataset.with : mountSummary.dataset.without;
      const mountProperty = this.querySelector('[data-print-mount-property]');
      mountProperty.disabled = this.materialKey !== 'dibond';
      mountProperty.value = includesMount ? 'inklusive Aufhängung' : 'Ohne Aufhängung';
      this.querySelector('[data-print-material-property]').value = material.label;
      this.querySelector('[data-print-format-property]').value = row.format;
      const shipping = this.querySelector('[data-print-shipping]');
      shipping.textContent = this.delivery === 'POST' ? shipping.dataset.post : shipping.dataset.pdf;
      const variant = this.variantFor(this.materialKey,row,this.delivery,this.mount);
      const hidden = this.querySelector('[data-print-variant]');
      hidden.value = variant ? variant.id : '';
      hidden.disabled = !this.canBuy();
      const button = this.querySelector('[data-print-submit]');
      button.disabled = !this.canBuy();
      button.textContent = this.canBuy() ? button.dataset.add : button.dataset.preparing;
      this.querySelector('[data-print-status]').hidden = this.canBuy();
      this.querySelector('[data-print-error]').hidden = true;
    }
    updatePersonal() {
      ['recipient','sender','message'].forEach(key => {
        const input = this.querySelector('[data-print-personal="' + key + '"]');
        const output = this.querySelector('[data-print-preview-' + key + ']');
        output.textContent = input.value.trim();
        output.hidden = !input.value.trim();
      });
    }
  }
  customElements.define('fdbs-print-configurator',FdbsPrintConfigurator);
}
function fdbsSyncGiftPanels() {
  const print = window.location.hash === '#druck-gutscheine';
  document.querySelectorAll('[data-fdbs-gift-panel]').forEach(panel => { panel.hidden = (panel.dataset.fdbsGiftPanel === 'print') !== print; });
  document.querySelectorAll('[data-fdbs-gift-tab]').forEach(link => {
    if ((link.dataset.fdbsGiftTab === 'print') === print) link.setAttribute('aria-current','page');
    else link.removeAttribute('aria-current');
  });
  document.querySelectorAll('[data-fdbs-shooting-faq]').forEach(section => { section.hidden = print; });
}
window.addEventListener('hashchange',fdbsSyncGiftPanels);
document.addEventListener('DOMContentLoaded',fdbsSyncGiftPanels);
document.addEventListener('shopify:section:load',fdbsSyncGiftPanels);
fdbsSyncGiftPanels();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fdbs-shooting-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fdbs-shooting-picker')) {
 class FdbsShootingPicker extends HTMLElement {
  connectedCallback() {
   if (this.onRoute) return;
   this.chooser=this.querySelector('[data-shoot-chooser]');
   this.panels=Array.from(this.querySelectorAll('[data-shoot-panel]'));
   this.onRoute=()=>this.route(true);
   window.addEventListener('hashchange',this.onRoute);
   window.addEventListener('popstate',this.onRoute);
   this.route(false);
  }
  disconnectedCallback() { window.removeEventListener('hashchange',this.onRoute);window.removeEventListener('popstate',this.onRoute);this.onRoute=null; }
  route(focus) {
   let hash=window.location.hash;
   const aliases={'#geschenk-family':'#geschenk-familie-klassik','#geschenk-family-plus':'#geschenk-familie-plus','#geschenk-children-baby':'#geschenk-familie-start'};
   hash=aliases[hash]||hash;
   const packageKey=hash.startsWith('#geschenk-')?hash.slice('#geschenk-'.length):'';
   const selectedPackage=Array.from(this.querySelectorAll('[data-shoot-package]')).find(item=>item.dataset.shootPackage===packageKey);
   const panel=selectedPackage?selectedPackage.closest('[data-shoot-panel]'):this.panels.find(item=>hash==='#'+item.id);
   this.chooser.hidden=Boolean(panel);
   this.panels.forEach(item=>{item.hidden=item!==panel;});
   if(panel&&selectedPackage) selectedPackage.querySelector('details').open=true;
   if(focus&&panel) requestAnimationFrame(()=>{const title=panel.querySelector('h3');title.focus({preventScroll:true});(selectedPackage||panel).scrollIntoView({block:'start'});});
  }
 }
 customElements.define('fdbs-shooting-picker',FdbsShootingPicker);
}
  } catch(e) { console.error(e); }
})();

})();
